
<!-- 智能电力//成本目标  -->
<template>
  <div class="box">
    <Title
      :text="electricity.BuildingEnergyConsumption.Title[0]"
      :engText="electricity.BuildingEnergyConsumption.Title[1]"
    ></Title>
    <div class="content">
      <div class="a1">
        [
        <div :class="`${active === 1 ? 'active' : ''}`" @click="fn1(1)">
          本日
        </div>
        <div :class="`${active === 2 ? 'active' : ''}`" @click="fn1(2)">
          本月
        </div>
        <div :class="`${active === 3 ? 'active' : ''}`" @click="fn1(3)">
          本年
        </div>
        ]
      </div>
      <div class="a2">
        <div class="echarts-content">
            <chart-block ref="echart"></chart-block>
          </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Title from "../../components/title/index.vue";
import { mapState, mapActions } from "pinia"; //引入映射函数
import useStore from "@/store/index"; //引入store
export default {
  components: {
    Title,
  },
  data () {
    return {
      // active 1:日，2:月，3:年
      active:1,
    }
  },
  computed: {
    ...mapState(useStore, ["electricity"]),
  },
  mounted () {
      this.$refs.echart.setOption(this.electricity.BuildingEnergyConsumption.Option);
  },
  methods: {
    fn1(i){
      this.active = i;
    }
  }
};
</script>
  
  <style scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* background-color: red; */
}
.content .a1 {
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content .a1 > div {
  margin: 0px 10px;
  font-size: 12px;
  cursor: pointer;
}
.content .a2 {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.active{
  text-shadow: 0px 4px 5px #488dff;
}
</style>